<template>
  <div class="radio" @click="onChange">
    <img v-if="checked" src="../assets/checked@3x.png" />
    <img v-else src="../assets/unchecked@3x.png" />
  </div>
</template>
<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  name: 'custom-radio',

  methods: {
    onChange() {
      this.$emit('onChange');
    },
  },
};
</script>

<style lang="sass" scoped src="./custom-radio.sass"></style>
